/* =========================

  which is name

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../../Styled/mixin";

// コンポーネント
import BtnStart from "../button/BtnStart";
import BtnSelect from "../button/BtnSelect";
import BtnFinish from "../button/BtnFinish";
// 各コンテンツ
import Keyvisual from "./Keyvisual";
import Question from "./Question";
import Finish from "./Finish";

import { useSelector,useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

/* -------------------------

  component

---------------------------- */
function Diagnoise( props ) {
  // const sum = useSelector((state)=>state.sum);
  const count = useSelector((state)=>state.count)
  const datas = useSelector((state)=>state.datas);
  const resultDatas = useSelector((state)=>state.resultDatas);
  const dispatch = useDispatch();

  let navigate = useNavigate();

  let resultDirectory = "/result/";
  let qaArry = [];

  let cancelFlag = 0;
  const FormSubmitFunc = (e) => {
    e.preventDefault();
    if (cancelFlag === 0) {

      // 最終合計
      let checkedInputs = document.querySelectorAll(`form[name="pekemaru"] input:checked`);
      let checkedSum = 0;
      for(let j = 0 ; j < checkedInputs.length ; j++){
        checkedSum += Number(checkedInputs[j].value);
        qaArry.push(checkedInputs[j].getAttribute("data-answer"));
      }
      // console.log(`合計点数は${checkedSum}`);
      let param = qaArry.join("");
      dispatch({type:"ADD_SUM",payload:checkedSum});


      let transUrl = "";
      for(let i = 0;i < resultDatas.length; i++){
        if(
          (resultDatas[i].minNum_w <= checkedSum && checkedSum <= resultDatas[i].maxNum_w)
          || (resultDatas[i].minNum_m <= checkedSum && checkedSum <= resultDatas[i].maxNum_m)
          || (resultDatas[i].minNum_o <= checkedSum && checkedSum <= resultDatas[i].maxNum_o)
          ){
          transUrl = `${resultDirectory}${resultDatas[i].pageName}/?answer=${param}`;

          const http = new XMLHttpRequest();
          http.open(
            "GET",
            `/shindan${transUrl}`
          );
          http.send();

          navigate(`${transUrl}`);
          dispatch({"type":"ADD_COUNT","payload":0});
          dispatch({"type":"ADD_SUM","payload":0});

        }
      }
      cancelFlag = 1;
    }
    setTimeout(function () {
      cancelFlag = 0;
    }, 500);
  }

  return (
    <>
      <form name="pekemaru" method="post" onSubmit={FormSubmitFunc}>

        {/* 診断TOP */}
        <StyledStart id="start">
          <Keyvisual>
            <BtnStart>診断スタート！</BtnStart>
          </Keyvisual>
        </StyledStart>
        {/* 診断TOP */}

        {/* 選択画面 */}
        <StyledQuestion className={`${(count > 0)?"isFadeIn":"isDisplayNone"}`}>
        {datas.map((d,i)=>(
          <Question num={d.num} title={d.question} id={`question_${d.num}`} key={i}>
            {d.answer.map((a,j)=>(
              <BtnSelect num={j} questionNum={d.num} name={`answer_${d.num}`} value={`${d.answerValue[j]}`} id={`answer_${d.num}_${j}`} key={j} >
                {a}
              </BtnSelect>
            ))}
          </Question>
        ))}
        </StyledQuestion>
        {/* 選択画面 */}

        {/* 結果を見る画面 */}
        <StyledFinish id="finish" className={(datas.length >= count)?"isDisplayNone":"isFadeIn"}>
          <Finish>
            <BtnFinish id={"btn_finish"} formName={"pekemaru"}>
              結果を見る
            </BtnFinish>
          </Finish>
        </StyledFinish>
        {/* 結果を見る画面 */}

      </form>
    </>
  );
}

export default Diagnoise;

/* -------------------------

  styled

---------------------------- */
const StyledStart = styled.div`
	@media ${break_point_sp} {
	}
`;

const StyledQuestion = styled.div`
	@media ${break_point_sp} {
	}
`;
const StyledFinish = styled.div`
	@media ${break_point_sp} {
	}
`;
